import { ActionHandler, ActionKey, MenuItem } from '../../Types'
import { ReactComponent as MoveIcon } from 'assets/icons/moveDoc16.svg'
import { HandbookItem } from 'types'
import { setMoveModalVisible } from 'redux/actions'
import { useDispatch } from 'react-redux'

const createMovable = (label: string = '') => [{ key: ActionKey.move, textValue: label, Icon: MoveIcon } as const]

interface Movable {
  movable: MenuItem[]
  handleMove: ActionHandler
}

export const useMovable = (item: HandbookItem, actionLabel: string = ''): Movable => {
  const dispatch = useDispatch()

  const handleMove = (actionKey: ActionKey) => {
    if (actionKey !== ActionKey.move) return false

    dispatch(setMoveModalVisible(true))

    return true
  }

  return {
    movable: createMovable(actionLabel),
    handleMove: handleMove,
  }
}
